import { useEffect } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveFeed from "@/pages/home/components/LiveFeed";
import TodayGrid from "@/pages/home/components/TodayGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import TopicGrid from "@/pages/home/components/TopicGrid";
import TrustSection from "@/pages/home/components/TrustSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll<HTMLElement>(".reveal"));
    if (nodes.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <LiveFeed />
        <TodayGrid />
        <HotRanking />
        <TopicGrid />
        <TrustSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}